
import React from 'react';

interface SidePanelProps {
  side: 'left' | 'right';
}

const SidePanel: React.FC<SidePanelProps> = ({ side }) => {
  return (
    <div className={`h-full w-full relative overflow-hidden bg-transparent`}>
      
      {/* 1. Deep Space Gradient Background (Semi-transparent for stars) */}
      <div className={`absolute inset-0 bg-gradient-to-b ${side === 'left' ? 'from-indigo-950/40' : 'from-purple-950/40'} to-slate-950/20`} />

      {/* 2. SVG Art Layer */}
      <svg className="w-full h-full absolute inset-0" preserveAspectRatio="xMidYMid slice">
        <defs>
            <radialGradient id="planetGrad1" cx="30%" cy="30%" r="70%">
                <stop offset="0%" stopColor="#818cf8" />
                <stop offset="50%" stopColor="#4338ca" />
                <stop offset="100%" stopColor="#1e1b4b" />
            </radialGradient>
            <radialGradient id="planetGrad2" cx="70%" cy="20%" r="80%">
                <stop offset="0%" stopColor="#e879f9" />
                <stop offset="100%" stopColor="#701a75" />
            </radialGradient>
            <filter id="glow">
                <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
                <feMerge>
                    <feMergeNode in="coloredBlur"/>
                    <feMergeNode in="SourceGraphic"/>
                </feMerge>
            </filter>
        </defs>

        {/* --- DYNAMIC ARTWORK --- */}
        {side === 'left' ? (
            // Left Panel Art: Giant Planet rising from bottom
            <g>
                {/* Increased opacity from 0.8 to 1.0 for better visibility */}
                <circle cx="50%" cy="85%" r="40%" fill="url(#planetGrad1)" filter="url(#glow)" opacity="1.0" />
                {/* Rings */}
                <ellipse cx="50%" cy="85%" rx="55%" ry="10%" fill="none" stroke="#6366f1" strokeWidth="2" opacity="0.6" transform="rotate(-15, 50, 85)" />
                <ellipse cx="50%" cy="85%" rx="60%" ry="12%" fill="none" stroke="#818cf8" strokeWidth="1" opacity="0.4" transform="rotate(-15, 50, 85)" />
                
                {/* Tech Deco */}
                <rect x="10%" y="10%" width="2" height="100" fill="#312e81" opacity="0.8" />
                <rect x="15%" y="10%" width="2" height="60" fill="#312e81" opacity="0.5" />
            </g>
        ) : (
            // Right Panel Art: Distant Moon & Nebula
            <g>
                {/* Increased opacity */}
                <circle cx="70%" cy="20%" r="25%" fill="url(#planetGrad2)" filter="url(#glow)" opacity="0.9" />
                {/* Nebula Cloud Shape (Simple Blob) */}
                <path d="M0,80 Q50,60 100,80 T200,80 V100 H0 Z" fill="#4c1d95" opacity="0.4" filter="url(#glow)" />
                
                {/* Tech Deco */}
                <rect x="85%" y="40%" width="2" height="120" fill="#4c1d95" opacity="0.8" />
                <rect x="90%" y="40%" width="2" height="80" fill="#4c1d95" opacity="0.5" />
            </g>
        )}
      </svg>
      
      {/* 3. Text Overlay */}
      <div className={`absolute top-10 ${side === 'left' ? 'left-8' : 'right-8'} flex flex-col gap-2 opacity-50`}>
         <div className="h-1 w-12 bg-white/50 rounded-full mb-2"></div>
         <div className="text-[10px] font-mono uppercase tracking-[0.4em] text-white">
             {side === 'left' ? 'Sector 7G' : 'Deep Void'}
         </div>
      </div>

    </div>
  );
};

export default SidePanel;
